import React from 'react';
import { LoginForm } from '@features/auth/components/login-form/LoginForm';

const LoginPage: React.FC = () => {
  return <LoginForm />;
};

export default LoginPage;
